import React from 'react';
import { Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';
import { customError, customSuccess, warningYellow } from '../../../mainTheme';

interface FacilityStatusIconProps {
  status: 'ok' | 'warning' | 'critical';
}

const statusConfig = {
  ok: {
    icon: faCheckCircle,
    color: customSuccess,
  },
  warning: {
    icon: faExclamationCircle,
    color: warningYellow,
  },
  critical: {
    icon: faExclamationTriangle,
    color: customError,
  },
};

const FacilityStatusIcon: React.FC<FacilityStatusIconProps> = ({ status }) => {
  const config = statusConfig[status] || statusConfig.ok;
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        width: 24,
        height: 24,
        borderRadius: '50%',
      }}
    >
      <FontAwesomeIcon
        data-testid="facility-status-icon"
        icon={config.icon}
        color={config.color}
        size="lg"
      />
    </Box>
  );
};

export default FacilityStatusIcon;
